<template>
  <div id="app">
    <div class="nav_father">
      <div class="my_nav">
        <img @click="navto('/')" src="../../static/img/logo2.png" />
        <ul class="nav navbar-nav nav_ul" id="ul_header">
          <li class="nav_li nav_home">
          <el-popover
              placement="bottom-start"
              title=""
              width="200"
              trigger="hover"
              :visible-arrow="false"
              popper-class="my-popover"
              content="">

              <div class="li-pop-div">
                <p @click="scrollNavto('/','brand')">关于我们</p>
                <p @click="scrollNavto('/','business')">主营业务</p>
                <p @click="scrollNavto('/','case')">服务案例</p>
                <p @click="scrollNavto('/','news')">宏邦资讯</p>
                <p @click="scrollNavto('/','partner')">合作伙伴</p>
              </div>
            
              <a slot="reference" @click="navto('/')">首页</a>
            </el-popover>
          </li>
          <li class="nav_li nav_honor">
            
            <el-popover
              placement="bottom-start"
              title=""
              width="200"
              trigger="hover"
              :visible-arrow="false"
              popper-class="my-popover"
              content="">

              <div class="li-pop-div">
                <p @click="scrollNavto('/Honor','brand')">公司简介</p>
                <p @click="scrollNavto('/Honor','wenhua')">企业文化</p>
                <p @click="scrollNavto('/Honor','tuandui')">团队介绍</p>
                <p @click="scrollNavto('/Honor','honor')">荣誉资质</p>
              </div>
              <a  slot="reference" @click="navto('/Honor')">关于我们</a>
            </el-popover>
          </li>
          <li class="nav_li nav_business">
            
            <el-popover
              placement="bottom-start"
              title=""
              trigger="hover"
              :visible-arrow="false"
              popper-class="my-popover"
              content="">

              <div class="li-pop-div">
                <p @click="scrollNavto('/Safe','honor-div-1')">安防护卫</p>
                <p @click="scrollNavto('/Safe','honor-div-2')">消防服务</p>
                <p @click="scrollNavto('/Safe','honor-div-3')">保安培训</p>
                <p @click="scrollNavto('/Safe','honor-div-4')">物业服务</p>
                <p @click="scrollNavto('/Safe','honor-div-5')">安检设备租售</p>
              </div>
              <a  slot="reference" @click="navto('/Safe')">主营业务</a>
            </el-popover>
          </li>
          <li class="nav_li nav_case">
            <a @click="navto('/SafeCase')">服务案例</a>
          </li>
          <li class="nav_li nav_news">
            <a @click="navto('/News/News')">宏邦资讯</a>
          </li>
          <li class="nav_li nav_callus">
            
            <el-popover
              placement="bottom-start"
              title=""
              trigger="hover"
              :visible-arrow="false"
              popper-class="my-popover"
              content="">

              <div class="li-pop-div">
                <p @click="scrollNavto('/CallUs','')">联系方式</p>
                <p @click="scrollNavto('/CallUs','callus')">在线留言</p>
              </div>
              <a  slot="reference" @click="navto('/CallUs')">联系我们</a>
            </el-popover>
          </li>
          <li class="nav_end_li">
            <a class="nav_right_img"
              ><img src="../../static/img/nav_phone.png" />400-687-7123</a
            >
          </li>
        </ul>
      </div>
      <div class="nav_down" v-show="downnavshow">
        <div class="nav_down_brand" v-show="businessshow">
          <div @click="navto('/Food')" class="nav_down_brand_1">
            <div></div>
            <p>企事业餐饮运营</p>
          </div>
          <div @click="navto('/Safe')" class="nav_down_brand_2">
            <div></div>
            <p>人防技防安保服务</p>
          </div>
          <div @click="navto('/Service')" class="nav_down_brand_3">
            <div></div>
            <p>物业管理服务</p>
          </div>
        </div>
        <div class="nav_down_product" v-show="caseshow">
          <div @click="navto('/FoodCase')" class="nav_down_brand_1">
            <div></div>
            <p>餐饮服务案例</p>
          </div>
          <div @click="navto('/SafeCase')" class="nav_down_brand_2">
            <div></div>
            <p>安保服务案例</p>
          </div>
        </div>
      </div>
    </div>
    <div class="phone_nav">
      <div class="phone_my_nav">
        <img
          class="phone_logo"
          src="../../static/img/logo2.png"
          @click="navto('/')"
        />
        <div class="phone_mune_div">
          <img
            v-show="!isOpenSlider"
            class="phone_mune_logo"
            src="../../static/img/汉堡栏.png"
            @click="openSilder()"
          />
          <img
            v-show="isOpenSlider"
            class="phone_mune_logo"
            src="../../static/img/nav_close.png"
            @click="openSilder()"
          />
        </div>
      </div>

      <div
        class="w3-sidebar w3-bar-block w3-animate-right"
        style="display: none"
        id="mySidebar"
      >
        <div class="siderbar_close" @click="closeSilder()">
          <p></p>
        </div>
        <div class="siderbar_div">
          <p class="w3-bar-item w3-button w3-item1" @click="navto('/')">
            首 页
          </p>
          <p class="w3-bar-item w3-button w3-item1" @click="navto('/Honor')">
            关于我们
          </p>
          <p class="w3-bar-item w3-button w3-item1" @click="navto('/Safe')">
            主营业务
          </p>
          <!-- <button
            class="w3-button w3-block w3-left-align w3-item1"
            @click="myProductFunc()"
          >
            业务介绍 <i class="fa fa-caret-down"></i>
          </button>
          <div id="productAcc" class="w3-hide w3-white">
            <a class="w3-bar-item w3-button w3-item2" @click="navto('/Food')"
              >企事业餐饮运营</a
            >
            <a class="w3-bar-item w3-button w3-item2" @click="navto('/Safe')"
              >人防技防安保服务</a
            >
            <a class="w3-bar-item w3-button w3-item2" @click="navto('/Service')"
              >物业管理服务</a
            >
          </div> -->
          <!-- <button
            class="w3-bar-item w3-button w3-item1"
            @click="navto('/SafeCase')"
          >
            服务案例 <i class="fa fa-caret-down"></i>
          </button> -->
          <!-- <div id="videoAcc" class="w3-hide w3-white">
            <a
              class="w3-bar-item w3-button w3-item2"
              @click="navto('/FoodCase')"
              >餐饮服务案例</a
            >
            <a
              class="w3-bar-item w3-button w3-item2"
              @click="navto('/SafeCase')"
              >安保服务案例</a
            >
          </div> -->
          <a class="w3-bar-item w3-button w3-item1" @click="navto('/SafeCase')"
            >服务案例</a
          >
          <a class="w3-bar-item w3-button w3-item1" @click="navto('/News/News')"
            >宏邦资讯</a
          >
          <a class="w3-bar-item w3-button w3-item1" @click="navto('/CallUs')"
            >联系我们</a
          >
        </div>
      </div>
    </div>

    <keep-alive>
      <router-view :key="$route.fullpath" style="padding-top:8rem"></router-view>
    </keep-alive>
    <div class="foot">
      <div class="container" style="width: 80%">
        <div class="row footgone" style="padding: 10rem 0">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                  <div class="foot_logo_div">
                    <img src="../../static/img/logo3.png" />
                  </div>
                </div>
          <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7">
            <div>
              <div class="row">
                <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
                  <div class="Medium_title MediumClick" @click="navto('/')">首页</div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/', 'brand')"
                  >
                    关于我们
                  </div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/', 'business')"
                  >
                    主营业务
                  </div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/', 'case')"
                  >
                    服务案例
                  </div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/', 'news')"
                  >
                    宏邦资讯
                  </div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/', 'partner')"
                  >
                    合作伙伴
                  </div>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
                  <div class="Medium_title MediumClick" @click="navto('/Honor')">关于我们</div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/Honor', 'brand')"
                  >
                    公司简介
                  </div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/Honor', 'wenhua')"
                  >
                    企业文化
                  </div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/Honor', 'tuandui')"
                  >
                    团队介绍
                  </div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/Honor', 'honor')"
                  >
                    荣誉资质
                  </div>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
                  <div class="Medium_title MediumClick" @click="navto('/Safe')">主营业务</div>
                  <div class="Medium MediumClick" @click="scrollNavto('/Safe', 'honor-div-1')">
                    安防护卫
                  </div>
                  <div class="Medium MediumClick" @click="scrollNavto('/Safe', 'honor-div-2')">
                    消防服务
                  </div>
                  <div class="Medium MediumClick" @click="scrollNavto('/Safe', 'honor-div-3')">
                    保安培训
                  </div>
                  <div class="Medium MediumClick" @click="scrollNavto('/Safe', 'honor-div-4')">
                    物业服务
                  </div>
                  <div class="Medium MediumClick" @click="scrollNavto('/Safe', 'honor-div-5')">
                    安检设备租售
                  </div>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
                  <div class="Medium_title MediumClick" @click="navto('/SafeCase')">服务案例</div>
                  <!-- <div class="Medium MediumClick" @click="navto('/FoodCase')">
                    餐饮运营案例
                  </div>
                  <div class="Medium MediumClick" @click="navto('/SafeCase')">
                    安保服务案例
                  </div> -->
                </div>
                <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
                  <div
                    class="Medium_title MediumClick"
                    @click="navto('/News/News')"
                  >
                    宏邦资讯
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                  <div
                    class="Medium_title MediumClick"
                    @click="navto('/CallUs')"
                  >
                    联系我们
                  </div>
                  <div class="Medium MediumClick" @click="scrollNavto('/CallUs', '')">
                    联系方式
                  </div>
                  <div class="Medium MediumClick" @click="scrollNavto('/CallUs', 'callus')">
                    在线留言
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
            <div class="foot_phone_div">
              <p class="txt">安保服务专线</p>
              <p class="number">400-687-7123</p>
              <img src="../../static/img/二维码.png" />
            </div>
          </div>
        </div>

        <div class="MediaTest">
          <p>
            宁波宏邦保安服务有限公司 Ningbo Hongbang Property Servicesco,Ltd.
          </p>
          <a href="https://beian.miit.gov.cn/">浙ICP备18008665号-1</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeBanner from "../components/HomeBanner.vue";
export default {
  components: {
    HomeBanner,
  },
  name: "App",
  data() {
    return {
      isOpenSlider: false,
      downnavshow: false,
      businessshow: false,
      caseshow: false,
      fouce: true,
      LogoImg: "",
      WxGZHImg: "",
      mainurl: "",
      input: "",
      footer: [],
      activeIndex: "1",
      // clientWight: "",
    };
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      console.log(to.path);
      if(to.path){
        this.justShowLine(to.path);
      }else{
        this.justShowLine('/');

      }
      
    },
  },
  mounted() {
    // this.showActive();
    var pathname = window.location.pathname;
    this.justShowLine(pathname);
  },
  methods: {
    scrollNavto(path, name) {
      console.log(path);
      this.resetShow();
      $(".nav_home a").removeClass("active");
      $(".nav_honor a").removeClass("active");
      $(".nav_business a").removeClass("active");
      $(".nav_case a").removeClass("active");
      $(".nav_news a").removeClass("active");
      $(".nav_callus a").removeClass("active");
      // this.showActive();
      if (path === "/") {
        $(".nav_home a").addClass("active");
      } else if (path === "/Honor") {
        $(".nav_honor a").addClass("active");
      }else if (path === "/Safe") {
        $(".nav_business a").addClass("active");
      }else if (path === "/CallUs") {
        $(".nav_callus a").addClass("active");
      }
      this.$router.push({
        path: `${path}`,
        query: { param: name },
      });
    },
    justShowLine(path) {
      // $(".collapse.in").removeClass("in");
      this.resetShow();
      this.downnavshow = false;
      $(".nav_home a").removeClass("active");
      $(".nav_honor a").removeClass("active");
      $(".nav_business a").removeClass("active");
      $(".nav_case a").removeClass("active");
      $(".nav_news a").removeClass("active");
      $(".nav_callus a").removeClass("active");
      // this.showActive();
      if (path === "/") {
        $(".nav_home a").addClass("active");
      } else if (path === "/Honor") {
        $(".nav_honor a").addClass("active");
      } else if (path === "/Food") {
        $(".nav_business a").addClass("active");
      } else if (path === "/Safe") {
        $(".nav_business a").addClass("active");
      } else if (path === "/Service") {
        $(".nav_business a").addClass("active");
      } else if (path === "/FoodCase") {
        $(".nav_case a").addClass("active");
      } else if (path.indexOf("/SafeCase")!=-1 ) {
        $(".nav_case a").addClass("active");
      } else if (path .indexOf("/News")!=-1 ) {
        $(".nav_news a").addClass("active");
      } else if (path === "/CallUs") {
        $(".nav_callus a").addClass("active");
      }
    },
    navto(path) {
      // $(".collapse.in").removeClass("in");
      this.resetShow();
      this.downnavshow = false;
      $(".nav_home a").removeClass("active");
      $(".nav_honor a").removeClass("active");
      $(".nav_business a").removeClass("active");
      $(".nav_case a").removeClass("active");
      $(".nav_news a").removeClass("active");
      $(".nav_callus a").removeClass("active");
      // this.showActive();
      if (path === "/") {
        $(".nav_home a").addClass("active");
      } else if (path === "/Honor") {
        $(".nav_honor a").addClass("active");
      } else if (path === "/Food") {
        $(".nav_business a").addClass("active");
      } else if (path === "/Safe") {
        $(".nav_business a").addClass("active");
      } else if (path === "/Service") {
        $(".nav_business a").addClass("active");
      } else if (path === "/FoodCase") {
        $(".nav_case a").addClass("active");
      } else if (path === "/SafeCase") {
        $(".nav_case a").addClass("active");
      } else if (path === "/News/News") {
        $(".nav_news a").addClass("active");
      } else if (path === "/CallUs") {
        $(".nav_callus a").addClass("active");
      }
      this.$router.push(path);
      // this.showActive();
    },
    resetShow() {
      this.downnavshow = false;
      this.businessshow = false;
      this.caseshow = false;
      this.closeSilder();
    },
    showDownNav(id) {
      this.downnavshow = true;
      this.businessshow = false;
      this.caseshow = false;
      if (id === "Business") {
        this.businessshow = true;
      } else if (id === "Case") {
        this.caseshow = true;
      }
    },
    showActive() {
      $("#ul_header li a").click(function (e) {
        $("#ul_header li a").removeClass("active");
        // $(this).addClass("active");
      });
    },
    openSilder() {
      if (this.isOpenSlider) {
        this.closeSilder();
      } else {
        this.isOpenSlider = true;
        document.getElementById("mySidebar").style.display = "flex";
      }
    },
    closeSilder() {
      this.resetSlider();
      this.isOpenSlider = false;
      document.getElementById("mySidebar").style.display = "none";
    },
    myAboutFunc() {
      var x = document.getElementById("aboutAcc");
      if (x.className.indexOf("w3-show") == -1) {
        this.resetSlider();
        x.className += " w3-show";
        x.previousElementSibling.className += " w3-green";
      } else {
        x.className = x.className.replace(" w3-show", "");
        x.previousElementSibling.className = x.previousElementSibling.className.replace(
          " w3-green",
          ""
        );
      }
    },
    myProductFunc() {
      var x = document.getElementById("productAcc");
      if (x.className.indexOf("w3-show") == -1) {
        this.resetSlider();
        x.className += " w3-show";
        x.previousElementSibling.className += " w3-green";
      } else {
        x.className = x.className.replace(" w3-show", "");
        x.previousElementSibling.className = x.previousElementSibling.className.replace(
          " w3-green",
          ""
        );
      }
    },
    myVideoFunc() {
      var x = document.getElementById("videoAcc");
      if (x.className.indexOf("w3-show") == -1) {
        this.resetSlider();
        x.className += " w3-show";
        x.previousElementSibling.className += " w3-green";
      } else {
        x.className = x.className.replace(" w3-show", "");
        x.previousElementSibling.className = x.previousElementSibling.className.replace(
          " w3-green",
          ""
        );
      }
    },
    resetSlider() {
      // var x1 = document.getElementById("videoAcc");
      // var x2 = document.getElementById("productAcc");
      // var x3 = document.getElementById("aboutAcc");

      // x1.className = x1.className.replace(" w3-show", "");
      // x1.previousElementSibling.className = x1.previousElementSibling.className.replace(
      //   " w3-green",
      //   ""
      // );

      // x2.className = x2.className.replace(" w3-show", "");
      // x2.previousElementSibling.className = x2.previousElementSibling.className.replace(
      //   " w3-green",
      //   ""
      // );

      // x3.className = x3.className.replace(" w3-show", "");
      // x3.previousElementSibling.className = x3.previousElementSibling.className.replace(
      //   " w3-green",
      //   ""
      // );
    },
  },
};
</script>
<style>
.el-popover {
  background: #000000 !important;
  border-radius: 0 !important;
  box-shadow:none !important;
  border:none !important;
  margin-top:0 !important;
  width:auto !important;
  color:var(--COLORE5) !important;
}
</style>
<style lang="stylus" scoped>
.nav_father {
  display: block;
  width: 100%;
  height: 8rem;
  z-index: 1030;
  position: fixed;
  top: 0;
  //box-shadow: 6px 6px 6px rgba(0, 0, 0, 0.2);
}

.nav_down {
  width: 100%;
  height: 10rem;
  background: var(--COLORE0E0E080);
  display: flex;
  justify-items: center;
  align-items: center;
  flex-direction: row-reverse;

  .nav_down_brand {
    margin-right: 60rem;
    /* margin-left: 45%; */
    display: flex;
    justify-items: center;
    align-items: center;
  }

  .nav_down_product {
    margin-right: 57rem;
    // margin-left: 56%;
    display: flex;
    justify-items: center;
    align-items: center;
  }

  .nav_down_video {
    margin-left: 53%;
    display: flex;
    justify-items: center;
    align-items: center;
  }

  div {
    margin: 0 4rem;
  }

  img {
    width: 4rem;
    height: 4rem;
    object-fit: contain;
  }

  p {
    color: var(--textBlack);
    font-size: 1.6rem;
    font-family: regular;
    // text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.4);
    margin: 5px 0 0;
  }
}

.nav_down_brand_1 {
  transition: all 0.4s;

  div {
    background-image: url('../../static/img/nav_icon1.png');
    background-repeat: no-repeat;
    background-size: contain;
    width: 4rem;
    height: 4rem;
    margin: auto;
    background-position: center;
  }
}

.nav_down_brand_1:hover {
  p {
    color: var(--textBlue);
  }

  div {
    background-image: url('../../static/img/nav_icon1-2.png');
  }

  transform: translateY(-0.2rem);
  transition: all 0.4s;
}

.nav_down_brand_2 {
  transition: all 0.4s;

  div {
    background-image: url('../../static/img/nav_icon2.png');
    background-repeat: no-repeat;
    background-size: contain;
    width: 4rem;
    height: 4rem;
    margin: auto;
    background-position: center;
  }
}

.nav_down_brand_2:hover {
  p {
    color: var(--textBlue);
  }

  div {
    background-image: url('../../static/img/nav_icon2-2.png');
  }

  transform: translateY(-0.2rem);
  transition: all 0.4s;
}

.nav_down_brand_3 {
  transition: all 0.4s;

  div {
    background-image: url('../../static/img/nav_icon3.png');
    background-repeat: no-repeat;
    background-size: contain;
    width: 4rem;
    height: 4rem;
    margin: auto;
    background-position: center;
  }
}

.nav_down_brand_3:hover {
  p {
    color: var(--textBlue);
  }

  div {
    background-image: url('../../static/img/nav_icon3-2.png');
  }

  transform: translateY(-0.2rem);
  transition: all 0.4s;
}

.phone_nav {
  display: none;
}

.phone_my_nav {
  height: 8rem;
  align-items: center;
  background: white;
  display: flex;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1030;
  justify-content: space-between;

  .phone_logo {
    margin-left: 2rem;
    width: 16rem;
    height: auto;
  }

  .phone_mune_div {
    position: relative;
    width: 3rem;
    height: 100%;
    margin-right: 2rem;
  }

  .phone_mune_logo {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 100%;
    height: auto;
  }
}

.siderbar_close {
  width: 30%;
}

.siderbar_div {
  width: 70%;
  background: var(--textBlueColor60);
}

.w3-sidebar {
  display: flex;
  width: 100%;
  height: 100%;
  right: 0;
  margin-top: 8rem;
  z-index: 10;
  background: transparent;
}

.w3-white {
  background-color: transparent !important;
}

.w3-green, .w3-hover-green:hover {
  background-color: var(--textBlueColor80) !important;
}

.fa {
  margin-left: 4rem;
}

.w3-item1 {
  margin: 0;
  background: transparent;
  padding: 2rem 2rem;
  font-size: 2rem;
  font-family: 'light';
  color: white;
  text-align: center !important;
  border: 1px solid var(--textWhiteColor20);
}

.w3-item2 {
  background: var(--textBlueColor80);
  padding: 2rem 2rem;
  font-size: 1.8rem;
  font-family: 'light';
  color: white;
  text-align: center !important;
  border: 1px solid var(--textWhiteColor20);
}

.w3-button:hover {
  text-decoration: none;
  color: white !important;
  background: var(--textBlueColor80) !important;
}

.my_nav {
  max-width:1920px;
  height: 8rem;
  align-items: center;
  background: white;
  display: flex;
  width: 100%;
  position: relative;
  z-index: 1030;
  text-align: center;

  img {
    margin-left: 13rem;
    object-fit: contain;
    // width: 24.3rem;
    height: 5rem;
  }

  ul {
    list-style-type: none;
    margin: auto;
    margin-right: 13rem;
    padding: 0;
    overflow: hidden;
    background: white;
  }

  li {
    float: left;
    margin: 0 1rem;
  }
}

.navbar-default .navbar-nav>.active>a, .navbar-default .navbar-nav>.active>a:focus, .navbar-default .navbar-nav>.active>a:hover {
  // background-color: var(--textBlue);
  // color: #fff;
}

.flex-container {
  display: flex;
  align-items: center;
}

.flex-container > div {
  padding: 0 20px 0 0;
}

.foot_msg_row {
  margin: 2rem auto;
  width: 90%;
}

.el-col:first-child {
  padding: 0;
}

.elcol {
  padding: 10px !important;
}

.foot {
  background-color: var(--COLORE182347);
  background-repeat: no-repeat;
  background-size: cover;
  color: #FFFFFF;
  margin: 0;
  width: 100%;
  font-size: 1.3rem;
  line-height: 2;
}

.Medium_title {
  text-align: left;
  font-size: 1.8rem;
}

.Medium {
  text-align: left;
  font-family: light;
  font-size: 1.7rem;
  color: var(--textWhiteColor50);
}

.MediumClick {
  cursor: pointer;
}

.MediaTest {
  display: flex;
  flex-direction: row;
  border-top: 0.5px solid white;
  margin: 0;
  padding: 1rem 0;
  text-align: right;
  color: var(--textWhiteColor50);
  font-size: 1.4rem;
  font-family: regular;

  a {
    margin-left: 5rem;
  }
}

.MediaTest span.active {
  visibility: hidden;
}

.foot-head {
  color: #888888;
  margin: 1rem 0;
}

.foot .foot-text+.foot-text {
  margin-left: 12rem;
}

.el-submenu__icon-arrow {
  position: unset;
}

.foot-logo {
  vertical-align: middle;
}

.foot-icon {
  width: 4.5rem;
}

.copyright {
  border-top: 0.1rem solid #444444;
  padding-top: 1rem;
}

.foot-body {
  cursor: pointer;
}

.foot_logo_div{
  img {
    width: auto;
    height: 8rem;
  }
}
.foot_phone_div {
  position: relative;
  text-align:left;

  img {
    width: 9rem;
    height: 9rem;
  }

  p {
    text-align: left;
    //margin: 3rem 0;
  }

  .txt{
    font-size:1.6rem;
    color:var(--textWhiteColor50);
    font-family:light;
    margin-bottom:0;
    line-height:1;
  }
  .number{
    font-family:DIN-Bold;
    font-size:3rem;
    margin-bottom:0;
    line-height:1.5;
  }

  div {
    position: absolute;
    bottom: 10%;
    left: 0;
    right: 0;
    margin: 0;
  }
}

.phone_foot_phone_div {
  display: none;
}

.foot-phone {
  line-height: 2.2rem;
  font-size: 2.2rem;
  font-family: medium;
  color: white;

  p {
    padding: 0.5rem;
  }
}

.navbar-default {
  background-image: none;
  background-color: #ffffff;
  box-shadow: none;
}

.navbar-brand, .navbar-nav>li>a {
  text-shadow: none;
  height: 5rem;
}

// .container {
// padding: 1rem 0;
// }
.my_navbar_container {
  padding: 0;
  // width:auto;
  display: flex;
  align-items: center;
  align-content: center;
  text-align: center;
  justify-content: center;
}

.navbar>.container .navbar-brand, .navbar>.container-fluid .navbar-brand {
  margin-left: 0 !important;
}

.container>.navbar-header {
  // margin-left: 15%;
  // left:3rem;
  // position:absolute;
}

.navbar-fixed-top {
  border-width: 0;
  width: 80%;
  margin: auto;
  margin-top: 3rem;
}

.navbar-brand {
  padding: 1rem 0;

  img {
    image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
    margin: auto;
    padding: 0;
    height: 100%;
  }
}

.nav_right_img {
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 5rem;
  padding: 0;
  text-align: center;
  font-size: 1.5rem;

  img {
    image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
    width: 3rem;
    margin: auto 1rem;
  }
}

.nav_ul {
  background-color: #fff;
  margin: 0 0 0 3rem;

  .nav_end_li a {
    height: 8rem;
    line-height: 8rem;
    padding: 0 0 0 1.5rem;
    font-size: 2.4rem;
    color: var(--textNavBlack);
    font-family: DIN-Bold;
  }

  .nav_end_li:hover {
    a {
      background: white;
    }
  }

  .nav_li a {
    outline:none;
    cursor: pointer;
    margin: 0 1rem 0 0;
    min-width: 10rem;
    height: 8rem;
    line-height: 8rem;
    padding: 0 1.5rem;
    color: var(--textNavBlack);
    font-size: 1.8rem;
    font-family: regular;
    display:block;
    text-decoration: none;
  }

  .nav_li a:hover:not(.active) {
    background-color: var(--textWhite);
    color: var(--textBlue);
    border-bottom: 3px solid var(--textBlue);
  }

  .active {
    background-color: var(--textWhite);
    color: var(--textBlue) !important;
    border-bottom: 3px solid var(--textBlue);
  }
}

.li-pop-div{
    display:flex;
    p{
      margin:1rem;
      cursor pointer;
    }
  }

@media (max-width: 1500px) {
  .container {
    width: 100%;
    padding-top: 0;
    padding-bottom: 0;
  }

  .navbar-fixed-top {
    padding: 0 1.5rem;
    width: 80% !important;
  }

  .nav_right_img {
    margin-top: auto;
    margin-bottom: auto;
    margin-left: 2rem;
    padding: 0;
    text-align: center;
    font-size: 1.5rem;

    img {
      width: 3rem;
      margin: 0 1rem;
    }
  }

  .foot-icon {
    width: 3rem;
  }

  .foot-phone {
    font-size: 2.5rem;
    line-height: 2.5rem;
  }
}

@media (max-width: 1000px) {
  .container {
    width: 100%;
    padding-top: 0;
    padding-bottom: 0;
  }

  .navbar-fixed-top {
    padding: 0 1.5rem;
    width: 100% !important;
  }

  .navbar-toggle {
    grid-float-breakpoint: 1000px;
  }

  .navbar-brand {
    height: 5rem;

    img {
      margin: auto;
      padding: 0;
      height: 3rem;
    }
  }

  .my_navbar_container {
    padding: 0;
    width: auto;
    display: block;
  }

  .nav_ul {
    background-color: #fff;

    .nav_li a {
      width: 100%;
      height: 5rem !important;
      line-height: 3rem !important;
      padding: 1rem 1rem !important;
      font-size: 1.4rem;
    }

    .nav_end_li a {
      height: 5rem;
      line-height: 5rem;
      padding: 0 1.5rem;
      font-size: 2rem;
    }
  }
}

@media (max-width: 850px) {
  .foot {
    font-size: 1.4rem;
  }

  .float-right {
    margin-top: 2rem;
  }

  // .nav_right_img{
  // margin-left:0 !important;
  // }
  .nav_ul {
    // background-color: #fff;
    margin: 0;

    .nav_li a {
      // width: 100%;
      // height: 5rem !important;
      // line-height: 3rem !important;
      padding: 1rem 1rem !important;
      font-size: 1.2rem;
    }

    .nav_end_li a {
      // height: 5rem;
      // line-height: 5rem;
      // padding: 0 1.5rem;
      font-size: 1.5rem;
    }
  }

  .navbar>.container .navbar-brand, .navbar>.container-fluid .navbar-brand {
    margin-left: 1rem !important;
  }
}

@media (min-width: 768px) {
  // .navbar-default {
  // width: 100%;
  // }

  // .visible-xs {
  // display: none;
  // }

  // .menu-btn {
  // float: right;
  // }

  // .menu-btn button {
  // float: right;
  // }
  .foot {
    margin-top: 0;
  }
}

@media (min-width: 1800px) {
  .foot {
    font-size: 1.4rem;
    line-height: 2;
  }

  .foot-icon {
    width: 4.5rem;
  }

  .MediaTest {
    padding: 1rem 0 0 0;
  }
}

@media (max-width: 1600px) {
  .nav_down {
    .nav_down_brand {
      margin-right: 55rem;
    }

    .nav_down_product {
      margin-right: 53rem;
    }
  }
}

@media (max-width: 1200px) {
  .my_navbar_container {
    width: 100%;
  }

  .phone_nav {
    display: block;
    box-shadow: 6px 6px 6px rgba(0, 0, 0, 0.2);
  }

  .MediaTest {
    padding: 0 1rem;
    flex-direction: column;
    text-align: left;

    a {
      margin: 0;
    }
  }

  .footgone {
    display: none;
  }

  .phone_foot_phone_div {
    display: block;
    position: relative;
    margin: 1rem;

    div {
      position: absolute;
      bottom: 13%;
      left: 0;
      right: 0;
      margin: 0;

      p {
        text-align: center;
      }
    }
  }

  .nav_father {
    display: none;
  }
}

@media (max-width: 800px) {
  .container {
    width: 100% !important;
    padding: 0;
  }

  .foot_msg_row {
    width: 100%;
  }

  .nav_right_img {
    img {
      width: 3rem;
    }
  }
}
</style>
